import React from 'react';
import styled from 'styled-components';
import loadingAnimationSource from './loading-animation.svg';

export const LoadingIndicator = () => (
  <Wrapper>
    <img src={loadingAnimationSource} alt="loading indicator"/>
  </Wrapper>
);

const Wrapper = styled.div`
  & > img {
    height: 64px;
  }
  display: flex;
  justify-content: center;
`;
